import React from 'react';
import { AlertTriangleIcon, CheckIcon, StarIcon } from 'lucide-react';
import { purchaseUrls } from '../data/content';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
const baseFeatures = ['6 Tomos PDF completos (Fundamentos, Suelo, Salto, Barras, Viga, Planificación)', 'Progresiones etapa por etapa en los 4 aparatos', '6 Bonos incluidos gratis (valor $70.000)', 'Inicial → Avanzado con variantes por nivel', 'Acceso inmediato + Garantía de 7 días'];
const premiumFeatures = ['TODO el Combo Completo Gimnasia Artística 2026', 'Macrociclo anual de 48 semanas listo para aplicar', '4 trimestres detallados con plan por nivel y objetivos', 'Protocolo de 8 semanas pre-competencia', 'Rutinas de gestión del entrenador + kit completo de materiales', 'Evaluación anual comparativa lista para imprimir'];
function PlanCard({
  premium = false
}: {
  premium?: boolean;
}) {
  const features = premium ? premiumFeatures : baseFeatures;
  const title = premium ? 'COMBO COMPLETO + ACADEMIA 12 MESES' : 'COMBO COMPLETO GIMNASIA ARTÍSTICA';
  const subtitle = premium ? '6 Tomos + 6 Bonos + Planificación anual semana a semana' : '6 Tomos + 6 Bonos · Inicial → Avanzado · Los 4 aparatos';
  const price = premium ? '$27.990' : '$19.990';
  const before = premium ? '$75.000' : '$55.000';
  const savings = premium ? '$47.010' : '$35.010';
  return <article className={`relative flex flex-col rounded-3xl p-6 md:p-8 ${premium ? 'border-2 border-gold bg-surface shadow-[0_25px_70px_rgba(245,199,75,.18)] md:scale-[1.025]' : 'border border-line bg-surface'}`} data-id="element-240" data-mp="3d9qpofrj9cut">
      {premium && <p className="absolute -top-4 left-1/2 flex -translate-x-1/2 items-center gap-1 whitespace-nowrap rounded-full bg-gold px-4 py-1.5 text-xs font-black uppercase text-ink" data-id="element-241" data-mp="3rydd74rbdax4">
          <StarIcon aria-hidden="true" className="h-4 w-4 fill-current" data-id="element-242" data-mp="2zhkkfopx4qa5" /> Más elegido
        </p>}
      <div className={premium ? 'mt-2' : ''} data-id="element-243" data-mp="2rguzve1otwdq">
        <div className="flex items-start gap-2" data-id="element-244" data-mp="2rfjwhfc5mqn5">
          <span aria-hidden="true" className="text-3xl" data-id="element-245" data-mp="2mhrtnq9z1k46">
            {premium ? '🏆' : '📘'}
          </span>
          <h3 className="text-xl font-black uppercase leading-tight text-white" data-id="element-246" data-mp="316ekao51tyap">{title}</h3>
        </div>
        <p className={`mt-2 text-sm font-medium ${premium ? 'text-gold-soft' : 'text-zinc-400'}`} data-id="element-247" data-mp="2w71npbodlcux">
          {subtitle}
        </p>
      </div>

      <ul className="my-6 flex-1 space-y-2" data-id="element-248" data-mp="28iinljfhc6dx">
        {features.map(feature => <li key={feature} className="flex items-start gap-2 text-sm font-medium text-zinc-300" data-id="element-249" data-mp="23k7fbd4u23xt">
            <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-gold" data-id="element-250" data-mp="2igy4yuopg1a8" />
            {feature}
          </li>)}
      </ul>

      <div className="mb-6 mt-auto" data-id="element-251" data-mp="3tvbr9v3t88o5">
        <span className={`mb-3 inline-block rounded-full px-3 py-1 text-xs font-black uppercase ${premium ? 'bg-gold text-ink' : 'bg-gold/15 text-gold'}`} data-id="element-252" data-mp="3tuae9l38hc3s">
          Ahorrás {savings}
        </span>
        <p className="mt-2 text-sm font-bold text-zinc-600 line-through" data-id="element-253" data-mp="cglw5hup72i">Antes: {before}</p>
        <p className="mt-1 text-xs font-bold uppercase tracking-[.14em] text-zinc-500" data-id="element-254" data-mp="5arvcf48hfk7">Hoy</p>
        <p className="text-4xl font-black text-gold md:text-5xl" data-id="element-255" data-mp="3ngwfsgi91085">
          {price} <span className="text-base font-bold text-zinc-400" data-id="element-256" data-mp="3rhq61gj5yr47">ARS</span>
        </p>
      </div>

      <Button href={premium ? purchaseUrls.premium : purchaseUrls.base} fullWidth variant={premium ? 'gold' : 'outline'} className="text-xs md:text-sm" data-id="element-257" data-mp="j1wnkw59v5ki">
        {premium ? 'Quiero el Combo + Academia 12 Meses →' : 'Quiero mi Combo Completo →'}
      </Button>
    </article>;
}
export function Pricing({
  id = 'pricing'
}: {
  id?: string;
}) {
  return <section id={id} className="mx-auto max-w-6xl scroll-mt-16 px-4 py-16 md:py-24" data-id="element-258" data-mp="11zh9bucqpo0w">
      <div className="text-center" data-id="element-259" data-mp="16qzeyvppkcs7">
        <p className="text-[11px] font-extrabold uppercase tracking-[.16em] text-gold md:text-sm" data-id="element-260" data-mp="16s0q106q4z9x">
          ⏰ Precio de lanzamiento — cierra en:
        </p>
        <div className="mt-6" data-id="element-261" data-mp="3a7w7pzhi2ifr">
          <Countdown data-id="element-262" data-mp="3a7nv88pahf53" />
        </div>
        <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-263" data-mp="3aas59mpfr53o">
          {['Después sube $8.000 ARS. No vuelve.', '71% de los cupos al precio de lanzamiento ya tomados'].map(item => <span key={item} className="inline-flex items-center gap-1 rounded-full border border-red-500/40 bg-red-500/10 px-3 py-1.5 text-[11px] font-bold text-red-300" data-id="element-264" data-mp="1t5gxp8r93d1">
              <AlertTriangleIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-265" data-mp="3o7f27phe1v9l" />
              {item}
            </span>)}
        </div>
      </div>

      <h2 className="mt-14 text-center text-3xl font-black uppercase text-white md:text-5xl" data-id="element-266" data-mp="3k4shs9n1rcmf">
        Elegí tu <span className="text-gold" data-id="element-267" data-mp="kkyc9qbar0nx">Combo Completo</span>
      </h2>
      <div className="mx-auto mt-12 grid max-w-5xl items-stretch gap-8 md:grid-cols-2" data-id="element-268" data-mp="fqu3d1ih0ik7">
        <PlanCard data-id="element-269" data-mp="1yggcuzn3yy1q" />
        <PlanCard premium data-id="element-270" data-mp="1ygzknnj1o621" />
      </div>
      <p className="mt-9 text-center text-xs font-medium text-zinc-500" data-id="element-271" data-mp="23dybnx7evww0">
        🔒 Pago 100% seguro · ⚡ Acceso en 5 minutos · 🛡️ Garantía 7 días · 💳 Mercado Pago | Tarjeta
        | Transferencia
      </p>
    </section>;
}